import { BehaviorSubject } from 'rxjs';

export const instance$ = new BehaviorSubject((undefined as unknown) as any);

export const getInstance$ = () => instance$;

export const setInstance$ = (instance: string) => instance$.next(instance);
